<div [formGroup]="searchAssistancesListForm">
  <div *ngIf="!contactID || contactID == 0" class="ibox-content m-b-sm border-bottom">
    <div class="row" style="padding: 10px 15px;">
      <auto-complete apply-enter [controllerName]="'DonationCategories'" [placeholder]="'קטגוריה...'"
      (onSelect)="indexService.selectionChanged($event)" [formGroupModel]="searchAssistancesListForm"
      [idControl]="searchAssistancesListForm.controls.donationCategoryID" [nameControl]="searchAssistancesListForm.controls.donationCategoryTitle">
    </auto-complete>
          &nbsp;&nbsp;
          <auto-complete apply-enter [controllerName]="'Contacts'" [placeholder]="'איש...'"
               (onSelect)="indexService.selectionChanged($event)" [formGroupModel]="searchAssistancesListForm"
               [idControl]="searchAssistancesListForm.controls.contactID" [nameControl]="searchAssistancesListForm.controls.contactName">
             </auto-complete>

      &nbsp;&nbsp;
      <span fxFlex class="example-fill-remaining-space"></span>
      <div *ngIf="!contactID" fxLayoutAlign="start center" style="text-align:left" class="example-button-row">
        <button mat-mini-fab color="primary" title="סנן" (click)="indexService.getList()"> <i
            class="fa fa-filter"></i></button>
        &nbsp;
        <button mat-mini-fab color="primary" title="נקה סינונים" (click)="indexService.clerFilter()"><i
            class="material-icons">clear</i></button>
      </div>
    </div>
  </div>
  <div class="example-container" *ngIf="indexService" fxLayout="column" fxFlexFill>
    <div fxFlex>
      <cdk-virtual-scroll-viewport testCDK [full-height]="!contactID" #test itemSize="10"
        [ngStyle]="{'height':  'calc(100vh - '+ actualMinusHeight +'px)'}">
        <mat-table #table style="width: 100%;" *ngIf="indexService?.sourceList; else loading"
          [dataSource]="indexService.sourceList" (matSortChange)="indexService.sortData($event)" class="example-table"
          matSort matSortDisableClear matSortDirection="asc">
          <!-- <ng-container matColumnDef="select">
            <mat-header-cell style=" padding-right: 0;" *matHeaderCellDef>
              <span style="color: #FFFFFF; background-color: #ff4081;" class="label label-primary"
                *ngIf="selection?.selected?.length > 0">{{ selection?.selected?.length }}</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let row">
              <mat-checkbox apply-enter (click)="$event.stopPropagation()" (change)="$event ? rowToggle(row) : null"
                [checked]="selection.isSelected(row)">
              </mat-checkbox>
            </mat-cell>
          </ng-container> -->

          <ng-container matColumnDef="buttons">
            <mat-header-cell *matHeaderCellDef>...</mat-header-cell>
            <mat-cell *matCellDef="let row">
              <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <a mat-menu-item [routerLink]="[ '', {outlets: {popup: [ 'assistances', row.assistanceID]}}]">
                  <mat-icon>pageview</mat-icon>
                  <span>פרטים מלאים</span>
                </a>

                <a mat-menu-item [routerLink]="['', {outlets: {popup: ['assistances', row.assistanceID, 'edit']}}]">
                  <mat-icon>edit</mat-icon>
                  <span>עריכה</span>
                </a>

                <a mat-menu-item>
                  <mat-icon>information</mat-icon>
                  <model-info style="padding: 4px" [dataProvider]="assistancesData" [id]="row.assistanceID"
                    [title]="'מידע רשומה'">
                  </model-info>
                </a>
              </mat-menu>
            </mat-cell>
          </ng-container>


          <ng-container matColumnDef="assistanceID">
            <mat-header-cell *matHeaderCellDef mat-sort-header> מזהה </mat-header-cell>
            <mat-cell *matCellDef="let row" data-label="מזהה">
              <a [routerLink]="[ '', {outlets: {popup: [ 'assistances', row.assistanceID]}}]">
                {{ row.assistanceID }}
              </a>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="contactName">
            <mat-header-cell *matHeaderCellDef mat-sort-header>שם איש</mat-header-cell>
            <mat-cell style="font-weight: 500;" *matCellDef="let row" data-label="שם איש">
              <a [routerLink]="[ '/contacts', row.contactID]">{{ row.contactName }}</a>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="assistanceDate">
            <mat-header-cell *matHeaderCellDef mat-sort-header> תאריך
            </mat-header-cell>
            <mat-cell *matCellDef="let row" data-label="תאריך">
              {{ row.assistanceJewishDate }} <br> {{ row.assistanceDate | date:'dd/MM/yyyy' }}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="amount">
            <mat-header-cell *matHeaderCellDef mat-sort-header> סכום </mat-header-cell>
            <mat-cell *matCellDef="let row" data-label="סכום"> {{ row.amount | number}}{{
              row.currencyIcon }}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="reason">
            <mat-header-cell *matHeaderCellDef mat-sort-header>סיבה
            </mat-header-cell>
            <mat-cell *matCellDef="let row" data-label="סיבה"> {{ row.reason }}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="comment">
            <mat-header-cell *matHeaderCellDef mat-sort-header>הערה
            </mat-header-cell>
            <mat-cell *matCellDef="let row" data-label="הערה"> {{ row.comment }}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="donationCategoryTitle">
            <mat-header-cell *matHeaderCellDef mat-sort-header>קטגוריה
            </mat-header-cell>
            <mat-cell *matCellDef="let row" data-label="קטגוריה"> {{ row.donationCategoryTitle }}
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns;" (dblclick)="openSelectedRow(row.assistanceID)">
          </mat-row>
        </mat-table>
      </cdk-virtual-scroll-viewport>
    </div>
    <div fxFlex="15">
      <mat-paginator (page)="indexService.pageChange($event)" [showFirstLastButtons]="true" [hidePageSize]="false"
        [length]="indexService.rowsCount" [pageSize]="indexService.pageRows" [pageSizeOptions]="[10, 25, 30, 50, 100]">
      </mat-paginator>
    </div>
  </div>
</div>


<ng-template #loading>
  <h3 style="text-align: center;">
    טוען נתונים...
  </h3>
</ng-template>
